import { page } from "@randajan/jet-react/base/page";
import tab from "@randajan/jet-react/base/tab";
import { screen } from "@randajan/jet-react/base/screen";

tab.set("srcTag", page.pull("search.srcTag"));
tab.set("voucher", page.pull("search.voucher"));
tab.setDefault("menuVisible", true);


screen.config({
    widths:[380, 450, 700, 960, 1280, 1920],
    heights:[300, 600, 920, 1280]
});